module.exports = __webpack_public_path__ + "img/drifting-luminescence-2.f48a6cb4.webp";